/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveDirectoryUserIdRequest
 */
export interface ActiveDirectoryUserIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdRequest
     */
    cipher: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdRequest
     */
    tag: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdRequest
     */
    nonce: string;
}

/**
 * Check if a given object implements the ActiveDirectoryUserIdRequest interface.
 */
export function instanceOfActiveDirectoryUserIdRequest(value: object): value is ActiveDirectoryUserIdRequest {
    if (!('cipher' in value) || value['cipher'] === undefined) return false;
    if (!('tag' in value) || value['tag'] === undefined) return false;
    if (!('nonce' in value) || value['nonce'] === undefined) return false;
    return true;
}

export function ActiveDirectoryUserIdRequestFromJSON(json: any): ActiveDirectoryUserIdRequest {
    return ActiveDirectoryUserIdRequestFromJSONTyped(json, false);
}

export function ActiveDirectoryUserIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveDirectoryUserIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cipher': json['cipher'],
        'tag': json['tag'],
        'nonce': json['nonce'],
    };
}

export function ActiveDirectoryUserIdRequestToJSON(json: any): ActiveDirectoryUserIdRequest {
    return ActiveDirectoryUserIdRequestToJSONTyped(json, false);
}

export function ActiveDirectoryUserIdRequestToJSONTyped(value?: ActiveDirectoryUserIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cipher': value['cipher'],
        'tag': value['tag'],
        'nonce': value['nonce'],
    };
}

